import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a252e08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header is-sticky" }
const _hoisted_2 = {
  key: 0,
  class: "header__funnel"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "//dam.malt.com/cms-front/maltLogo.png",
  alt: "Malt Logo",
  loading: "lazy",
  width: "110",
  height: "32"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "aria-current": "page",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//dam.malt.com/cms-front/maltLogo.png",
    alt: "Malt Logo",
    loading: "lazy",
    width: "125",
    height: "37"
  })
], -1))
const _hoisted_6 = { class: "menus" }
const _hoisted_7 = {
  class: "header-megamenus",
  role: "tablist"
}
const _hoisted_8 = { class: "user-controls" }
const _hoisted_9 = { class: "header-user-slice-wrapper" }
const _hoisted_10 = { class: "mobile-search" }
const _hoisted_11 = { class: "user-controls" }
const _hoisted_12 = { class: "header-user-slice-wrapper" }
const _hoisted_13 = {
  key: 1,
  class: "desktop-content"
}
const _hoisted_14 = { class: "header-links" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "aria-current": "page",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//dam.malt.com/cms-front/maltLogo.png",
    alt: "Malt Logo",
    width: "110",
    height: "32"
  })
], -1))
const _hoisted_16 = { class: "header-megamenus" }
const _hoisted_17 = { class: "header-customized-zone" }
const _hoisted_18 = { class: "header-user-slice-wrapper" }

import {computed, inject, provide, ref} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {PrismicDocument, Slice} from '@prismicio/types';
    import {CountrySliceSlice, HeaderSearchSliceSlice} from '@/unlogged/prismicio';
    import {components} from '@/unlogged/slices';
    import {PRISMIC_HEADER_DOCUMENT, USER_LOCALE, MEDIA_BREAKPOINTS} from '@/unlogged/keys';
    import CountrySelection from './CountrySelection.vue';
    import HeaderSearch from './HeaderSearch.vue';
    import {getPageLocale} from '@malt/dom';
    import {useWindowNavGlobals} from '@/unlogged/composables/useWindowNavGlobals';

    type Props = {
        navbarDocument: PrismicDocument;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationHeader',
  props: {
    navbarDocument: {}
  },
  setup(__props: any) {

const props = __props;

    

    const alwaysShowSearch = ref(false);

    const header = computed(() => props.navbarDocument);
    const headerSlices = computed(() => header.value.data.slices as Slice[]);

    const {navTypeFunnel, searchFormVisible} = useWindowNavGlobals();

    const locale = getPageLocale();

    provide(PRISMIC_HEADER_DOCUMENT, header.value);
    provide(USER_LOCALE, locale);

    const breakpoints = inject(MEDIA_BREAKPOINTS);

    const isSearchOpen = ref(false);
    const isMenuOpen = ref(false);

    function toggleSearchModal() {
        isSearchOpen.value = !isSearchOpen.value;
        isMenuOpen.value = false;
    }

    function toggleMenu() {
        isMenuOpen.value = !isMenuOpen.value;
        isSearchOpen.value = false;
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_unref(navTypeFunnel))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(breakpoints) && _unref(breakpoints).isTablet)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({'mobile-content': true, 'menu-open': isSearchOpen.value})
              }, [
                _createElementVNode("button", {
                  class: "burger-button",
                  onClick: toggleMenu
                }, [
                  (isMenuOpen.value)
                    ? (_openBlock(), _createBlock(_component_VJoyIcon, {
                        key: 0,
                        name: "cross",
                        class: "close-icon"
                      }))
                    : (_openBlock(), _createBlock(_component_VJoyIcon, {
                        key: 1,
                        name: "bars",
                        class: "menu-icon"
                      }))
                ]),
                _hoisted_5,
                _createElementVNode("button", { onClick: toggleSearchModal }, [
                  (isSearchOpen.value)
                    ? (_openBlock(), _createBlock(_component_VJoyIcon, {
                        key: 0,
                        name: "cross",
                        class: "close-icon"
                      }))
                    : (_openBlock(), _createBlock(_component_VJoyIcon, {
                        key: 1,
                        name: "search",
                        class: "search-icon"
                      }))
                ]),
                _createElementVNode("div", {
                  id: "mobile-menu",
                  class: _normalizeClass({modale: true, open: isMenuOpen.value})
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(SliceZone), {
                        slices: headerSlices.value.filter((slice) => slice.slice_type === 'megamenu'),
                        components: _unref(components)
                      }, null, 8, ["slices", "components"])
                    ]),
                    _createVNode(_unref(SliceZone), {
                      slices: headerSlices.value.filter((slice) => slice.slice_type === 'header_links_slice'),
                      components: _unref(components)
                    }, null, 8, ["slices", "components"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(SliceZone), {
                        components: _unref(components),
                        slices: headerSlices.value.filter((slice) => slice.slice_type === 'header_user_slice')
                      }, null, 8, ["components", "slices"])
                    ]),
                    _createVNode(CountrySelection, {
                      "country-slice": (headerSlices.value.find((slice) => slice.slice_type === 'country_slice') as CountrySliceSlice),
                      locale: _unref(locale)
                    }, null, 8, ["country-slice", "locale"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  id: "mobile-search",
                  class: _normalizeClass({modale: true, open: isSearchOpen.value}),
                  "hide-backdrop": "",
                  "hide-header": "",
                  "hide-footer": ""
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(SliceZone), {
                      slices: [headerSlices.value.find((slice) => slice.slice_type === 'header_search_slice') as HeaderSearchSliceSlice],
                      components: _unref(components)
                    }, null, 8, ["slices", "components"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(SliceZone), {
                        slices: headerSlices.value.filter((slice) => slice.slice_type === 'header_user_slice'),
                        components: _unref(components)
                      }, null, 8, ["slices", "components"])
                    ]),
                    _createVNode(CountrySelection, {
                      "country-slice": (headerSlices.value.find((slice) => slice.slice_type === 'country_slice') as CountrySliceSlice),
                      locale: _unref(locale)
                    }, null, 8, ["country-slice", "locale"])
                  ])
                ], 2)
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  (!_unref(searchFormVisible))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_unref(SliceZone), {
                            slices: headerSlices.value.filter((slice) => slice.slice_type === 'megamenu'),
                            components: _unref(components)
                          }, null, 8, ["slices", "components"])
                        ]),
                        _createVNode(_unref(SliceZone), {
                          slices: headerSlices.value.filter((slice) => slice.slice_type === 'header_links_slice'),
                          components: _unref(components)
                        }, null, 8, ["slices", "components"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(HeaderSearch, {
                    "header-search-slice": (headerSlices.value.find((slice) => slice.slice_type === 'header_search_slice') as HeaderSearchSliceSlice),
                    "always-show-search": alwaysShowSearch.value,
                    "search-placeholder-text": header.value.data.searchPlaceholderText,
                    "page-with-search": header.value.data.pageWithSearch
                  }, null, 8, ["header-search-slice", "always-show-search", "search-placeholder-text", "page-with-search"]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(SliceZone), {
                      slices: headerSlices.value.filter((slice) => slice.slice_type === 'header_user_slice'),
                      components: _unref(components)
                    }, null, 8, ["slices", "components"])
                  ]),
                  _createVNode(CountrySelection, {
                    "country-slice": (headerSlices.value.find((slice) => slice.slice_type === 'country_slice') as CountrySliceSlice),
                    locale: _unref(locale)
                  }, null, 8, ["country-slice", "locale"])
                ])
              ]))
        ], 64))
  ]))
}
}

})